<!--  -->
<template>
  <div>
    <Head></Head>

    <div class="home_top">
      <h2>
        <a
          :href="'/#/Article?id=' + message_list[0].id"
          v-if="message_list.length > 0"
        >
          {{ message_list[0].name }}
        </a>
      </h2>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <ul class="from_ul" v-if="hideuser">
              <li>
                <a :class="{ active: index == 1 }" @click="changeNav(1)"
                  >用户登录</a
                >
                <div v-if="index == 1" class="line">
                  <input
                    type="text"
                    v-model="loginForm.username"
                    placeholder="请输入用户注册的手机号"
                  />
                  <el-alert
                    v-show="showyhm"
                    title="用户手机号输入有误"
                    type="error"
                    show-icon
                  ></el-alert>
                  <input
                    type="password"
                    v-model="loginForm.password"
                    placeholder="请输入密码"
                  />
                  <el-alert
                    v-show="showmm"
                    title="密码错误！！"
                    type="error"
                    show-icon
                  ></el-alert>
                  <el-alert
                    v-show="showmmx"
                    title="密码不能低于6位或大于11位"
                    type="error"
                    show-icon
                  >
                  </el-alert>
                  <!-- <input
                    type="text"
                    v-model="loginForm.yzm"
                    placeholder="请输入验证码"
                  />
                  <el-alert
                    v-show="showyzm"
                    title="请输入正确的验证码"
                    type="error"
                    show-icon
                  >
                  </el-alert> -->
                  <div class="forget">
                    <div @click="ResetPassword">忘记密码</div>
                  </div>
                  <el-button :plain="true" @click="login" class="sign"
                    >登录</el-button
                  >
                </div>
              </li>
              <li>
                <a :class="{ active: index == 2 }" @click="changeNav(2)"
                  >用户注册</a
                >
                <div v-if="index == 2" class="line">
                  <div class="register">
                    <div class="ZcName register_box">
                      <!--                      <span>姓名</span>-->
                      <!--                      <span class="span1">:</span>-->
                      <input
                        type="text"
                        v-model="ZcForm.real_name"
                        placeholder="请输入姓名"
                      />
                    </div>
                    <div class="ZcTitle register_box">
                      <!--                      <span>手机号</span>-->
                      <!--                      <span class="span1">:</span>-->
                      <input
                        type="text"
                        v-model="ZcForm.phone"
                        placeholder="请输入手机号"
                      />
                    </div>

                    <div class="ZcPassword register_box">
                      <!--                      <span>密码</span>-->
                      <!--                      <span class="span1">:</span>-->
                      <input
                        type="password"
                        v-model="ZcForm.password"
                        placeholder="请输入密码"
                      />
                    </div>
                    <div class="ZcPasswordQr register_box">
                      <!--                      <span>确认密码</span>-->
                      <!--                      <span class="span1">:</span>-->
                      <input
                        type="password"
                        v-model="ZcForm.passwordQr"
                        placeholder="请输入确认密码"
                      />
                    </div>
                    <div class="ZcTj">
                      <input
                        type="text"
                        v-model="ZcForm.code"
                        placeholder="验证码"
                      />
                      <button v-show="djs" @click="registerOne">
                        点击获取
                      </button>
                      <div v-show="djsx" class="count">{{ count }}s后获取</div>
                    </div>
                    <div class="register_submit">
                      <el-button @click="register">注册登录</el-button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="User_info" v-if="showuser">
              <h3>用户信息</h3>
              <div class="info_box">
                <div class="info_img">
                  <img
                    src="../assets/img/user.jpg"
                    alt=""
                    v-if="id_photo == null || id_photo == ''"
                    style="object-fit: cover"
                  />

                  <img
                    :src="id_photo"
                    alt=""
                    style="object-fit: cover"
                    v-else
                  />
                </div>

                <div class="user_name">{{ real_name }}</div>
              </div>
              <div class="info_centent">
                <p><router-link to="/my">个人中心</router-link></p>
                <p @click="removeUser">退出登录</p>
              </div>
            </div>
            <div class="Reset" v-if="showReset">
              <h3>密码重置</h3>
              <div class="Reset_box">
                <input
                  type="text"
                  v-model="resetForm.mobile"
                  placeholder="请输入用户注册的手机号"
                />
                <el-alert
                  v-show="showyhm"
                  title="用户手机号输入有误"
                  type="error"
                  show-icon
                ></el-alert>
                <input
                  type="password"
                  v-model="resetForm.password"
                  placeholder="请输入新密码"
                />
                <input
                  type="password"
                  v-model="resetForm.password_confirmation"
                  placeholder="请再次确认新密码"
                />
                <el-alert
                  v-show="showres"
                  title="两次输入密码不一样，请修订"
                  type="error"
                  show-icon
                ></el-alert>
                <div class="reset_yzm">
                  <input
                    type="text"
                    v-model="resetForm.code"
                    placeholder="验证码"
                  />
                  <button v-show="djs" @click="send_ret_sms">点击获取</button>
                  <div v-show="djsx" class="count">{{ count }}s后获取</div>
                </div>
                <div class="resetLgoin">
                  <el-button class="resetLgoinBtn" @click="resetPass"
                    >重置密码</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="18" class="col_right">
          <div class="grid-content bg-purple-light content_right">
            <div class="information">
              <ul class="information_content">
                <div class="information_title"><span>丨</span>招聘信息</div>
                <li
                  v-for="(item, index) in job_information"
                  :key="index"
                  @click="selectMessage(item.id, item.name)"
                >
                  <div
                    :class="[
                      'information_content_tle',
                      { selected: item.id == job_information_checked },
                    ]"
                  >
                    {{ item.name }}
                  </div>
                </li>
              </ul>
              <div class="oth" v-if="job_information_checked > 0">
                <a
                  :href="
                    '/#/Recruit?navid=' +
                    job_information_checked +
                    '&name=' +
                    job_information_checked_name
                  "
                  >更多</a
                >
              </div>
              <ul class="detail">
                <li
                  v-for="(info, i) in message_list"
                  :key="i"
                  :class="[
                    'detail_li',
                    { is_show_red_words: info.is_show_red_words == 1 },
                  ]"
                >
                  <a :href="'/#/Article?id=' + info.id">
                    <div :title="info.name" class="article-title">
                      {{ info.name }}
                    </div>
                    <div class="article-time">{{ info.release_time }}</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <ul class="link_box">
            <li>
              <div><a href="">注册登录流程</a></div>
            </li>
            <li>
              <div><router-link to="/Number">报名人数</router-link></div>
            </li>
            <li>
              <div><router-link to="">招聘报名流程</router-link></div>
            </li>
            <li>
              <div>
                <a href="http://jxjy.ahharc.com/index.html" target="_blank"
                  >专业技术人员继续教育网络平台</a
                >
              </div>
            </li>
          </ul>
        </el-col>
        <el-col :span="18">
          <div class="exam">
            <div class="exam_top">
              <div>
                <span class="exam_title"><span>丨</span>考试信息</span>
                <span class="exam_ul">{{ exam_information.name }}</span>
              </div>

              <div>
                <a
                  :href="
                    '/#/Exam?navid=' +
                    exam_information.id +
                    '&type=' +
                    exam_information.type +
                    '&name=' +
                    exam_information.name
                  "
                  >更多</a
                >
              </div>
            </div>
            <div class="exam_btm">
              <div class="tab">
                <ul class="tab_top">
                  <li>招聘岗位</li>
                  <li>开始时间</li>
                  <li>结束时间</li>
                </ul>
                <ul class="tab_btm">
                  <li
                    :class="[
                      'tab_btm_li',
                      { is_show_red_words: info.is_show_red_words == 1 },
                    ]"
                    v-for="(info, i) in exam_list"
                    :key="i"
                  >
                    <div
                      class="tab_btm_li_box"
                      @click="signup(info.id, info.is_sign_up)"
                    >
                      <div :title="info.name" class="exam-title">
                        {{ info.name }}
                      </div>
                      <div>{{ info.start_time }}</div>
                      <div>{{ info.end_time }}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
export default {
  data() {
    return {
      real_name: "",
      id_photo: "",
      index: 1,
      hideuser: true, //
      showuser: false,
      showReset: false,
      showmm: false,
      showmmx: false,
      showyzm: false,
      showyhm: false,
      showres: false,
      djs: true,
      djsx: false,
      count: "",
      timer: null,
      loginForm: {
        username: "",
        password: "",
        yzm: "",
      },
      ZcForm: {
        real_name: "",
        phone: "",
        password: "",
        passwordQr: "",
        code: "",
      },
      resetForm: {
        mobile: "",
        password: "",
        password_confirmation: "",
        code: "",
      },
      job_information_checked: 0,
      job_information_checked_name: "",
      job_information: {},
      exam_information: {},
      message_list: {},
      exam_list: {},
    };
  },

  components: {
    Head,
    Footer,
  },

  computed: {},

  mounted() {
    var isLogin = localStorage.getItem("authorization");
    if (isLogin) {
      this.showuser = true;
      this.hideuser = false;
      this.showReset = false;
      this.getUserInfo();
    }
    this.real_name = localStorage.getItem("real_name");
    this.id_photo = localStorage.getItem("id_photo");

    this.getNav();
    this.initData();
  },

  methods: {
    changeNav(index) {
      if (index == 1) {
        this.index = 1;
      } else if (index == 2) {
        this.index = 2;
      }
    },

    getUserInfo() {
      let _this = this;
      this.request("api/auth/user_info", {}, "get").then((res) => {
        if (res.data.status == "success") {
          localStorage.setItem("real_name", res.data.data.real_name);
          localStorage.setItem("id_photo", res.data.data.id_photo);
          _this.real_name = res.data.data.real_name;
          _this.id_photo = res.data.data.id_photo;
        }
      });
    },

    //登录验证
    login() {
      let _this = this;
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      if (_this.loginForm.username === "") {
        this.showyhm = true;
      } else if (!reg.test(_this.loginForm.username)) {
        this.showyhm = true;
      }
      if (_this.loginForm.password === "") {
        this.showmm = true;
        return;
      } else if (
        _this.loginForm.password.length > 11 ||
        _this.loginForm.password.length < 6
      ) {
        this.showmmx = true;
        return;
      }
      let requestData = {
        mobile: _this.loginForm.username,
        password: _this.loginForm.password,
      };
      this.loginPost(requestData);
    },

    register() {
      let _that = this;
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      if (_that.ZcForm.phone === "") {
        _that.$message.error("请输入手机号");
        return;
      } else if (!reg.test(_that.ZcForm.phone)) {
        _that.$message.error("手机号码格式不正确");
        return;
      }
      if (_that.ZcForm.real_name === "") {
        _that.$message.error("姓名不能为空");
        return;
      }
      if (_that.ZcForm.password === "") {
        _that.$message.error("密码不能为空");
        return;
      }
      if (_that.ZcForm.password != _that.ZcForm.passwordQr) {
        _that.$message.error("两次输入密码不一样，请修订");
        return;
      }
      if (_that.ZcForm.code === "") {
        _that.$message.error("验证码不能为空");
        return;
      }

      let requestData = {
        mobile: _that.ZcForm.phone,
        password: _that.ZcForm.password,
        password_confirmation: _that.ZcForm.passwordQr,
        real_name: _that.ZcForm.real_name,
        code: _that.ZcForm.code,
      };
      this.request("api/auth/register", requestData, "post").then((res) => {
        if (res.data.status == "success") {
          //登录
          let loginData = {
            mobile: _that.ZcForm.phone,
            password: _that.ZcForm.password,
          };
          _that.loginPost(loginData);
        }
      });
    },
    registerOne() {
      let _that = this;
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      if (_that.ZcForm.phone === "") {
        _that.$message.error("请输入手机号");
        return;
      } else if (!reg.test(_that.ZcForm.phone)) {
        _that.$message.error("手机号码格式不正确");
        return;
      }

      let requestData = {
        mobile: _that.ZcForm.phone,
      };
      this.request("api/auth/send_reg_sms", requestData, "post").then((res) => {
        if (res.data.status == "success") {
          _that.$message.success("验证码发送成功！");
          //倒计时效果
          const count = 60;
          if (!_that.timer) {
            _that.count = count;
            _that.djs = true;
            _that.djsx = true;
            _that.timer = setInterval(() => {
              if (_that.count > 0 && _that.count <= count) {
                _that.count--;
              } else {
                _that.djs = true;
                _that.djsx = false;
                clearInterval(_that.timer);
                _that.timer = null;
              }
            }, 1000);
          }
        }
      });
    },

    resetPass() {
      let _that = this;
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      if (_that.resetForm.mobile === "") {
        _that.$message.error("请输入手机号");
        return;
      } else if (!reg.test(_that.resetForm.mobile)) {
        _that.$message.error("手机号码格式不正确");
        return;
      }
      if (_that.resetForm.password === "") {
        _that.$message.error("密码不能为空");
        return;
      }
      if (_that.resetForm.password != _that.resetForm.password_confirmation) {
        _that.$message.error("两次输入密码不一样，请修订");
        return;
      }
      if (_that.resetForm.code === "") {
        _that.$message.error("验证码不能为空");
        return;
      }

      let requestData = {
        mobile: _that.resetForm.mobile,
        password: _that.resetForm.password,
        password_confirmation: _that.resetForm.password_confirmation,
        code: _that.resetForm.code,
      };
      this.request("api/auth/ret_password", requestData, "post").then((res) => {
        if (res.data.status == "success") {
          _that.$message.success("密码重置成功！");
          _that.showReset = false;
          _that.showuser = false;
          _that.hideuser = true;
        }
      });
    },
    send_ret_sms() {
      let _that = this;
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      if (_that.resetForm.mobile === "") {
        _that.$message.error("请输入手机号");
        return;
      } else if (!reg.test(_that.resetForm.mobile)) {
        _that.$message.error("手机号码格式不正确");
        return;
      }

      let requestData = {
        mobile: _that.resetForm.mobile,
      };
      this.request("api/auth/send_ret_sms", requestData, "post").then((res) => {
        if (res.data.status == "success") {
          _that.$message.success("验证码发送成功！");
          //倒计时效果
          const count = 60;
          if (!_that.timer) {
            _that.count = count;
            _that.djs = true;
            _that.djsx = true;
            _that.timer = setInterval(() => {
              if (_that.count > 0 && _that.count <= count) {
                _that.count--;
              } else {
                _that.djs = true;
                _that.djsx = false;
                clearInterval(_that.timer);
                _that.timer = null;
              }
            }, 1000);
          }
        }
      });
    },

    loginPost(data) {
      let _this = this;
      _this.request("api/auth/login", data, "post").then((res) => {
        if (res.data.status == "success") {
          var authorization = res.headers["authorization"];
          localStorage.setItem("authorization", authorization);
          localStorage.setItem("real_name", res.data.data.real_name);
          localStorage.setItem("id_photo", res.data.data.id_photo);
          // _this.real_name = res.data.data.real_name;
          // _this.id_photo = res.data.data.id_photo;
          // _this.showuser = true;
          // _this.hideuser = false;
          // _this.showReset = false;
          location.reload();
        }
      });
    },
    //忘记密码
    ResetPassword() {
      this.showReset = true;
      this.showuser = false;
      this.hideuser = false;
    },

    //退出登录
    removeUser() {
      let _this = this;
      this.request("api/auth/logout", {}, "post").then((res) => {
        if (res.data.status == "success") {
          localStorage.removeItem("authorization");
          localStorage.removeItem("real_name");
          localStorage.removeItem("id_photo");
          _this.real_name = "";
          _this.id_photo = "";
          _this.showuser = false;
          _this.showReset = false;
          _this.hideuser = true;
        }
      });
    },

    getNav() {
      let _this = this;
      _this.request("api/index/nav", {}, "get").then((res) => {
        if (res.data.status == "success") {
          _this.job_information = res.data.data.job_information;
          _this.exam_information = res.data.data.exam_information[0];

          _this.job_information_checked = res.data.data.job_information[0].id;
          _this.job_information_checked_name =
            res.data.data.job_information[0].name;
        }
      });
    },

    initData() {
      let _this = this;
      _this.request("api/index", {}, "get").then((res) => {
        if (res.data.status == "success") {
          _this.message_list = res.data.data.message_list;
          let exam_list = res.data.data.exam_list;
          for (let i = 0; i < exam_list.length; i++) {
            exam_list[i]["start_time"] = exam_list[i]["start_time"].substring(
              0,
              10
            );
            exam_list[i]["end_time"] = exam_list[i]["end_time"].substring(
              0,
              10
            );
          }
          this.exam_list = exam_list;
        }
      });
    },

    selectMessage(navid, navname) {
      let _this = this;
      _this.request("api/index", { nav_id: navid }, "get").then((res) => {
        if (res.data.status == "success") {
          _this.job_information_checked = navid;
          _this.job_information_checked_name = navname;
          _this.message_list = res.data.data.message_list;
        }
      });
    },

    signup(id, is_sign_up) {
      if (this.isLogin() === false) {
        return;
      }
      if (is_sign_up == 0) {
        this.$router.push("/enroll?post_id=" + id);
      }
      if (is_sign_up == 1) {
        this.$router.push("/step?post_id=" + id);
      }
    },
  },
};
</script>
<style lang='less' scoped>
.active1 {
  background: linear-gradient(0deg, #2989cc 0%, #ffffff 100%);
}
.home_top {
  h2 {
    a {
      text-align: center;
      font-weight: bold;
      color: #ff0000;
      font-size: 0.5rem;
      max-width: 50%;
      margin: auto;
      margin-top: 0.5rem;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
  .el-row {
    padding: 0.51rem 0.68rem;
    .col_right {
      padding: 0 0.59rem;
    }
    .el-col {
      .grid-content {
        .User_info {
          width: 4.41rem;
          height: 5.97rem;
          background: #e8e8e880;
          border-radius: 10px;
          h3 {
            font-size: 0.33rem;
            color: #00a0e9;
            text-align: center;
            padding-top: 0.38rem;
          }
          .info_box {
            display: flex;
            justify-content: center;
            justify-content: space-around;
            height: 1.76rem;
            line-height: 1.76rem;
            margin-top: 0.57rem;
            .info_img {
              width: 1.76rem;
              height: 1.76rem;
              border-radius: 50%;
              display: inline-block;
              box-sizing: border-box;
              text-align: center;
              color: #fff;
              background: #c0c4cc;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                display: block;
                vertical-align: middle;
              }
            }
            .user_name {
              font-size: 0.33rem;
              color: #414040;
            }
          }
          .info_centent {
            p {
              font-size: 0.37rem;
              color: #000;
              text-align: center;
              padding: 0.2rem 0;
              cursor: pointer;
            }
            p:nth-of-type(1) {
              margin-top: 0.5rem;
            }
          }
        }
        .from_ul {
          width: 4.41rem;
          height: 5.97rem;
          background: #e8e8e880;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          position: relative;
          li {
            cursor: pointer;
            padding: 0.38rem 0.15rem;
            a {
              font-size: 0.33rem;
              color: #000;
            }
            .active {
              color: #00a0e9;
              border-bottom: 2px solid #00a0e9;
            }
            .line {
              position: absolute;
              top: 1.2rem;
              left: 0.4rem;
              display: flex;
              align-items: center;
              flex-direction: column;
              input {
                width: 3.61rem;
                height: 0.62rem;
                margin: 0.36rem 0;
                margin-bottom: 0.05rem;
                border-radius: 0.1rem;
                border: 1px solid #bfbfbf;
                font-size: 0.25rem;
                color: #838080;
                text-indent: 2em;
                background: #e8e8e80f;
              }
              .sign {
                font-size: 0.35rem;
                padding: 0.15rem;
                width: 2.05rem;
                color: #fff;
                background-color: #00a0e9;
                border-radius: 0.1rem;
                border: none;
                margin-top: 0.36rem;
              }
              .register {
                .register_box {
                  span {
                    position: absolute;
                    left: 0;
                    top: 0;
                    text-align: justify;
                    width: 1.04rem;
                    height: 0.44rem;
                    line-height: 0.44rem;
                    font-size: 0.25rem;
                    padding: 0 0.1rem;
                    color: #050000;
                    display: inline-block;
                    text-align-last: justify;
                  }
                  .span1 {
                    position: absolute;
                    left: 0.9rem;
                    height: 0.44rem;
                    line-height: 0.44rem;
                    top: 0;
                  }
                  input {
                    /*position: absolute;*/
                    /*left: 1.2rem;*/
                    /*top: 0;*/
                    /*margin: 0;*/
                    /*outline: medium;*/
                    /*border: 0;*/
                    /*width: 2.38rem;*/
                    /*height: 0.44rem;*/
                    /*text-indent: 0;*/

                    width: 3.61rem;
                    height: 0.62rem;
                    margin: 0.1rem 0;
                    margin-bottom: 0.05rem;
                    border-radius: 0.1rem;
                    border: 1px solid #bfbfbf;
                    font-size: 0.25rem;
                    color: #838080;
                    text-indent: 2em;
                    background: #e8e8e80f;
                    margin-left: 50%;
                    transform: translateX(-50%);
                  }
                }
                .ZcPasswordQr {
                  margin-bottom: 0;
                  span {
                    letter-spacing: -2px;
                    left: -0.02rem;
                    width: auto;
                  }
                }
                .ZcTj {
                  display: flex;
                  position: relative;
                  input {
                    outline: medium;
                    text-indent: 1em;
                    margin: 0.1rem 0;
                    width: 2rem;
                  }
                  button {
                    position: absolute;
                    right: 0;
                    top: 0.1rem;
                    border-radius: 0.1rem;
                    font-size: 0.28rem;
                    width: 1.45rem;
                    height: 0.6rem;
                    background-color: #00a0e9;
                  }
                  .count {
                    position: absolute;
                    right: 0;
                    top: 0.1rem;
                    font-size: 0.28rem;
                    line-height: 0.62rem;
                    width: 1.45rem;
                    text-align: center;
                    background-color: #00a0e9;
                    border-radius: 0.1rem;
                  }
                }
                .register_submit {
                  margin-top: 0.1rem;
                  text-align: center;
                  button {
                    font-size: 0.35rem;
                    padding: 0.15rem;
                    width: 2.05rem;
                    color: #fff;
                    background-color: #00a0e9;
                    border-radius: 0.1rem;
                    border: none;
                    margin: 0 auto;
                  }
                }
              }
              .forget {
                width: 100%;
                padding-top: 0.1rem;
                div {
                  float: right;
                  color: #888;
                }
                :hover {
                  color: #00a0e9;
                }
              }
            }
          }
        }
        .Reset {
          width: 4.41rem;
          height: 5.97rem;
          background: #e8e8e880;
          border-radius: 10px;
          justify-content: center;
          h3 {
            font-size: 0.33rem;
            color: #00a0e9;
            text-align: center;
            padding-top: 0.38rem;
          }
          .Reset_box {
            input {
              width: 3.61rem;
              height: 0.62rem;
              margin: 0.3rem 0;
              margin-bottom: 0.05rem;
              border-radius: 0.1rem;
              border: 1px solid #bfbfbf;
              font-size: 0.25rem;
              color: #838080;
              text-indent: 2em;
              background: #e8e8e80f;
              margin-left: 50%;
              transform: translateX(-50%);
            }
            .reset_yzm {
              position: relative;
              height: 1.3rem;
              input {
                width: 2rem;
                height: 0.62rem;
                border-radius: 0.1rem;
                border: 1px solid #bfbfbf;
                font-size: 0.25rem;
                color: #838080;
                text-indent: 2em;
                background: #e8e8e80f;
                margin-top: 0.37rem;
                margin-left: 1.4rem;
              }
              button {
                position: absolute;
                right: 0.4rem;
                top: 0.37rem;
                border-radius: 0.1rem;
                font-size: 0.27rem;
                width: 1.3rem;
                height: 0.6rem;
                background-color: #00a0e9;
                outline: medium;
              }
              .count {
                position: absolute;

                right: 0.4rem;
                top: 0.37rem;
                font-size: 0.27rem;
                border-radius: 0.1rem;
                font-size: 0.27rem;
                width: 1.3rem;
                height: 0.6rem;
                line-height: 0.6rem;
                background-color: #00a0e9;
              }
            }
            .resetLgoin {
              text-align: center;
              .resetLgoinBtn {
                font-size: 0.35rem;
                padding: 0.15rem;
                width: 2.05rem;
                color: #fff;
                background-color: #00a0e9;
                border-radius: 0.1rem;
                border: none;
                margin: 0 auto;
              }
            }
          }
        }
      }
      .content_right {
        margin-top: 0.38rem;
        .information {
          display: flex;
          cursor: pointer;

          flex-wrap: wrap;
          justify-content: space-between;
          .information_title {
            font-size: 0.42rem;
            color: #000;
            span {
              color: #00a0e9;
            }
          }

          .information_content {
            display: flex;
            margin-right: 0.7rem;
            li {
              .information_content_tle {
                color: #000;
                font-size: 0.33rem;
                padding: 0.1rem 0.4rem;
              }
              .information_content_tle:hover {
                background: linear-gradient(0deg, #2989cc 0%, #ffffff 100%);
              }
              .selected {
                background: linear-gradient(0deg, #2989cc 0%, #ffffff 100%);
              }
            }
          }
          .detail {
            width: 12rem;
            left: 0.7rem;
            margin-top: 0.13rem;
            padding-left: 0.7rem;
            .detail_li {
              padding: 0.17rem 0;

              list-style: disc;
              font-size: 0.29rem;
              color: #00a0e9;

              a {
                display: flex;
                justify-content: space-between;
                .article-title {
                  max-width: 10rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                }
              }
            }
            .is_show_red_words {
              color: red;
              a {
                color: red;
              }
            }
          }
        }
        .oth {
          line-height: 0.64rem;
          a {
            font-size: 0.21rem;
            color: #787777;
          }
        }
      }
      .link_box {
        display: flex;
        width: 4.41rem;
        flex-wrap: wrap;
        li {
          width: 2.04rem;
          height: 2.04rem;
          text-align: center;
          // line-height: 2.04rem;
          border-radius: 0.1rem;
          margin: 0.125rem 0;
          color: #fff;
          font-size: 0.42rem;
          div {
            margin-top: 50%;
            transform: translateY(-50%);
            a {
              color: #fff;
              word-wrap: break-word;
              margin-top: 50%;
              transform: translateY(-50%);
            }
          }
        }
        li:nth-of-type(1) {
          background-color: #f19149;
          margin-right: 0.33rem;
        }
        li:nth-of-type(2) {
          background-color: #e60012;
          div {
            width: 0.9rem;
            margin-left: 0.55rem;
          }
        }
        li:nth-of-type(3) {
          background-color: #fff100;
          margin-right: 0.33rem;
        }
        li:nth-of-type(4) {
          background-color: #00b7ee;
          color: #fff;
          font-size: 0.33rem;
        }
      }
      .exam {
        cursor: pointer;
        margin-top: -0.3rem;
        padding-left: 0.59rem;
        .exam_top {
          display: flex;
          justify-content: space-between;
          .exam_title {
            font-size: 0.42rem;
            color: #000;
            span {
              color: #ff0000;
            }
          }
          .exam_ul {
            font-size: 0.33rem;
            color: #000;
            padding: 0.1rem 0.4rem;
            margin-right: 7rem;
            background: linear-gradient(0deg, #ff0000 0%, #ffffff 100%);
          }
          div {
            a {
              font-size: 0.21rem;
              color: #787777;
            }
          }
        }
        .exam_btm {
          .tab {
            width: 12rem;
            padding-left: 0.7rem;
            .tab_top {
              display: flex;
              li {
                font-size: 0.29rem;
                color: #5a5959;
                text-align: center;
                padding: 0.37rem 0;
              }
              li:nth-of-type(1) {
                flex: 3;
              }
              li:nth-of-type(2) {
                flex: 1;
              }
              li:nth-of-type(3) {
                flex: 1;
              }
            }
            .tab_btm {
              .tab_btm_li {
                list-style: disc;
                .tab_btm_li_box {
                  display: flex;
                  div {
                    font-size: 0.29rem;
                    color: #2e2e2e;
                    padding: 0.1rem 0;
                    text-align: center;
                  }
                  div:nth-of-type(1) {
                    flex: 3;
                    text-align: center;
                    overflow: hidden;

                    text-overflow: ellipsis;

                    white-space: nowrap;
                  }
                  div:nth-of-type(2) {
                    flex: 1;
                  }
                  div:nth-of-type(3) {
                    flex: 1;
                  }
                }
              }
              .is_show_red_words {
                color: red;
                .tab_btm_li_box {
                  div {
                    color: red;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
